var _rect, _rect2, _rect3, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAll(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 8,
    height: 8,
    rx: 2.5,
    fill: "#5a5673"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 3,
    width: 8,
    height: 8,
    rx: 2.5,
    fill: "#5a5673"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13,
    width: 8,
    height: 8,
    rx: 2.5,
    fill: "#5a5673"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 17,
    r: 4,
    fill: "#5a5673"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAll);
export default __webpack_public_path__ + "static/media/ic-all.474c56aec7bfed333add2c35c0a48336.svg";
export { ForwardRef as ReactComponent };